import { Card } from 'antd';

const CardNarrowInset = Card;
CardNarrowInset.defaultProps = { bodyStyle: { padding: '1em', width: '100%' } };

export { CardNarrowInset };
